<div class="audit-tab-body" style="position: relative">
  <div class="diag-wrap">
    <div class="diag-empty" *ngIf="firstLoad && !taskErrorsData">
      <p>No diagnostics data available for this audit yet.</p>
    </div>

    <ng-container *ngIf="firstLoad && taskErrorsData">
      <div class="cat-sel-head">
        <h3 class="cat-metric-title">Site health — error diagnostics</h3>
        <p class="cat-metric-desc">
          Which performance, rendering or structural issues limit opportunity
          capture.
        </p>
      </div>
      <!-- ── Top grid ── -->
      <div class="diag-top-grid">
        <!-- Errors by page -->
        <div class="diag-card">
          <h3 class="diag-title">Errors by page</h3>
          <div class="diag-pages">
            <div
              class="diag-page-row"
              *ngFor="let p of pageBars"
              (click)="pageChangedFilter(p.name)"
            >
              <div class="diag-page-head">
                <span class="diag-page-name">{{ p.name }}</span>
                <span class="diag-page-count">{{ p.value }}</span>
              </div>
              <div class="diag-page-track">
                <div class="diag-page-fill" [style.width]="p.width"></div>
              </div>
            </div>
            <div class="diag-none" *ngIf="pageBars.length === 0">
              No page data
            </div>
          </div>
        </div>

        <!-- Errors by category (donut) -->
        <!-- <div class="diag-card diag-card--center">
          <h3 class="diag-title diag-title--full">Errors by category</h3>
          <svg
            viewBox="0 0 160 160"
            width="150"
            height="150"
            class="diag-donut"
          >
            <circle
              class="wa-ring-track"
              cx="80"
              cy="80"
              [attr.r]="donutR"
              fill="none"
              stroke-width="20"
            ></circle>
            <circle
              *ngFor="let s of donutSegments"
              cx="80"
              cy="80"
              [attr.r]="donutR"
              fill="none"
              [attr.stroke]="s.color"
              stroke-width="20"
              [attr.stroke-dasharray]="s.dash"
              [attr.stroke-dashoffset]="s.offset"
              transform="rotate(-90 80 80)"
            ></circle>
            <text
              class="diag-donut-total"
              x="80"
              y="76"
              text-anchor="middle"
              font-size="30"
              font-weight="500"
            >
              {{ donutTotal }}
            </text>
            <text
              class="diag-donut-sub"
              x="80"
              y="98"
              text-anchor="middle"
              font-size="11"
            >
              errors
            </text>
          </svg>
          <div class="diag-legend">
            <div
              class="diag-legend-row"
              *ngFor="let s of donutSegments"
              (click)="typeChanged(s.name)"
            >
              <span class="diag-legend-dot" [style.background]="s.color"></span>
              <span class="diag-legend-name">{{ s.name }}</span>
              <span class="diag-legend-val">{{ s.value }}</span>
            </div>
            <div class="diag-none" *ngIf="donutSegments.length === 0">
              No category data
            </div>
          </div>
        </div> -->

        <!-- Total errors over time -->
        <div class="diag-card">
          <h3 class="diag-title">Total errors over time</h3>

          <ng-container *ngIf="errorSummaryData">
            <!-- KPI row -->
            <div class="diag-err-kpi">
              <span class="diag-err-num">{{
                errorSummaryData.currentErrors
              }}</span>
              <span
                *ngIf="errorSummaryData.hasDelta"
                class="diag-err-delta"
                [style.color]="errorSummaryData.deltaColor"
                >{{ errorSummaryData.deltaText }}</span
              >
            </div>

            <!-- Competitor note -->
            <div
              class="diag-err-note"
              *ngIf="errorSummaryData.compNote"
              [style.color]="errorSummaryData.compNoteColor || null"
            >
              {{ errorSummaryData.compNote }}
            </div>

            <!-- Trend chart (same Google LineChart as UX/CR) -->
            <div
              class="wa-legend"
              *ngIf="errorTrendHasData && errorTrendLegend?.length"
              style="margin: 8px 0"
            >
              <button
                type="button"
                class="wa-legend-item"
                *ngFor="let l of errorTrendLegend"
                [class.off]="!l.isYou && !l.visible"
                [class.locked]="l.isYou"
                (click)="toggleTrendLine(l)"
              >
                <span
                  class="wa-legend-dash"
                  [style.background]="l.color"
                ></span>
                {{ l.label }}
              </button>
            </div>
            <div class="diag-err-chart" *ngIf="errorTrendHasData">
              <google-chart [data]="errorTrendChart"></google-chart>
            </div>
          </ng-container>

          <div class="diag-none" *ngIf="!errorSummaryData">No summary data</div>
        </div>
      </div>

      <!-- ── Filters ── -->
      <div class="diag-filters">
        <mat-form-field
          class="bhm-option-container-1"
          style="
            --label-name: &quot;Type:&quot;;
            --form-field-infix-width: 200px;
          "
        >
          <mat-select
            (selectionChange)="typeChanged($event)"
            [(ngModel)]="selectedType"
          >
            <mat-select-trigger
              ><span style="text-transform: capitalize">{{
                selectedType
              }}</span></mat-select-trigger
            >
            <mat-option class="bhm-option-select-option-1" value="overall"
              >Overall</mat-option
            >
            <mat-option
              class="bhm-option-select-option-1"
              *ngFor="let type of types"
              [value]="type"
            >
              <span style="text-transform: capitalize">{{ type }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          class="bhm-option-container-1"
          style="
            --label-name: &quot;Page:&quot;;
            --form-field-infix-width: 160px;
          "
        >
          <mat-select
            [(ngModel)]="pageFilterActive"
            (selectionChange)="pageChangedFilter(pageFilterActive)"
          >
            <mat-option class="bhm-option-select-option-1" value="overall"
              >Show All</mat-option
            >
            <mat-option
              class="bhm-option-select-option-1"
              *ngFor="let p of pageBars"
              [value]="p.name"
              >{{ p.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>

        <span
          class="diag-clear"
          (click)="clearFilters()"
          *ngIf="pageFilterActive != 'overall' || selectedType != 'overall'"
        >
          Clear filters
        </span>
      </div>

      <!-- ── Errors table (standard custom_table) ── -->
      <div class="custom_table-container custom_table-container-v2">
        <table class="custom_table diag-errors-table">
          <colgroup>
            <col style="width: 58px" />
            <col style="width: 120px" />
            <col />
            <col style="width: 150px" />
            <col style="width: 120px" />
            <col style="width: 300px" />
          </colgroup>
          <thead>
            <tr>
              <th><div>#</div></th>
              <th><div>Page</div></th>
              <th><div>Issue</div></th>
              <th class="sort-value">
                <div>
                  Impact
                  <svg
                    (click)="sortData('impact')"
                    class="custom_table_sort-icon"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    [ngClass]="{
                      active: sortKey === 'impact' && sortOrder === 'asc',
                    }"
                  >
                    <path
                      d="M12 8V15"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16 12L12 8"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 12L12 8"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </th>
              <th class="sort-value">
                <div>
                  Score
                  <svg
                    (click)="sortData('score')"
                    class="custom_table_sort-icon"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    [ngClass]="{
                      active: sortKey === 'score' && sortOrder === 'asc',
                    }"
                  >
                    <path
                      d="M12 8V15"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16 12L12 8"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 12L12 8"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </th>
              <th><div>URL</div></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let error of errors; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ error.category }}</td>
              <td>{{ error.issue }}</td>
              <td>
                <span
                  class="diag-badge"
                  [ngClass]="impactClass(error.impact)"
                  style="text-transform: capitalize"
                  >{{ error.impact }}</span
                >
              </td>
              <td>
                <span class="diag-badge" [ngClass]="scoreClass(error.score)">{{
                  error.score
                }}</span>
              </td>
              <td>
                <a
                  class="diag-url"
                  [href]="error.url"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span
                    class="diag-url-text"
                    [matTooltip]="error.url"
                    matTooltipPosition="above"
                  >
                    {{ error.url }}
                  </span>
                  <mat-icon class="diag-url-open">open_in_new</mat-icon>
                </a>
              </td>
            </tr>
            <tr *ngIf="errors.length === 0">
              <td colspan="6" style="text-align: center">No errors found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <div class="diag-loading" *ngIf="!firstLoad">Loading diagnostics…</div>

    <div class="loading-data-overlay" *ngIf="isLoading && firstLoad">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <!-- Competitor switch overlay -->
    <div class="loading-data-overlay" *ngIf="competitorSwitching$ | async">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
</div>
